import Helper from "./common/helper";
import Header from "./common/header";
import ScrollControl from "./lib/scroll/scroll-control";
import Address from "./common/address";

import "core-js/full";

export default class Index {
    constructor() {
        this.init();
    }

    init() {
        this.helper = new Helper()
        this.header = new Header();

        this.scrollControl = new ScrollControl();
        this.address = new Address();
        this.address.init(this.scrollControl);
    }
}

window.onload = function() {
    new Index();
}

